import { render, staticRenderFns } from "./AccueilView.vue?vue&type=template&id=1b3d8254&scoped=true&"
import script from "./AccueilView.vue?vue&type=script&lang=js&"
export * from "./AccueilView.vue?vue&type=script&lang=js&"
import style0 from "./AccueilView.vue?vue&type=style&index=0&id=1b3d8254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d8254",
  null
  
)

export default component.exports